export default "__VITE_ASSET__DdOxXTma__"